
export interface Currency {
  code: string;
  name: string;
  symbol?: string;
  minorUnits?: number;
}
export const CURRENCIES: Currency[] = [
  { code: 'AED', name: 'United Arab Emirates Dirham', symbol: 'د.إ', minorUnits: 2 },
  { code: 'AFN', name: 'Afghan Afghani', symbol: '؋', minorUnits: 2 },
  { code: 'ALL', name: 'Albanian Lek', symbol: 'L', minorUnits: 2 },
  { code: 'AMD', name: 'Armenian Dram', symbol: '֏', minorUnits: 2 },
  { code: 'ANG', name: 'Netherlands Antillean Guilder', symbol: 'ƒ', minorUnits: 2 },
  { code: 'AOA', name: 'Angolan Kwanza', symbol: 'Kz', minorUnits: 2 },
  { code: 'ARS', name: 'Argentine Peso', symbol: '$', minorUnits: 2 },
  { code: 'AUD', name: 'Australian Dollar', symbol: '$', minorUnits: 2 },
  { code: 'AWG', name: 'Aruban Florin', symbol: 'ƒ', minorUnits: 2 },
  { code: 'AZN', name: 'Azerbaijani Manat', symbol: '₼', minorUnits: 2 },

  { code: 'BAM', name: 'Bosnia-Herzegovina Convertible Mark', symbol: 'KM', minorUnits: 2 },
  { code: 'BBD', name: 'Barbadian Dollar', symbol: '$', minorUnits: 2 },
  { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳', minorUnits: 2 },
  { code: 'BGN', name: 'Bulgarian Lev', symbol: 'лв', minorUnits: 2 },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: '.د.ب', minorUnits: 3 },
  { code: 'BIF', name: 'Burundian Franc', symbol: 'Fr', minorUnits: 0 },
  { code: 'BMD', name: 'Bermudan Dollar', symbol: '$', minorUnits: 2 },
  { code: 'BND', name: 'Brunei Dollar', symbol: '$', minorUnits: 2 },
  { code: 'BOB', name: 'Bolivian Boliviano', symbol: 'Bs.', minorUnits: 2 },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', minorUnits: 2 },
  { code: 'BSD', name: 'Bahamian Dollar', symbol: '$', minorUnits: 2 },
  { code: 'BTN', name: 'Bhutanese Ngultrum', symbol: 'Nu.', minorUnits: 2 },
  { code: 'BWP', name: 'Botswanan Pula', symbol: 'P', minorUnits: 2 },

  { code: 'CAD', name: 'Canadian Dollar', symbol: '$', minorUnits: 2 },
  { code: 'CDF', name: 'Congolese Franc', symbol: 'Fr', minorUnits: 2 },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', minorUnits: 2 },
  { code: 'CLP', name: 'Chilean Peso', symbol: '$', minorUnits: 0 },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', minorUnits: 2 },
  { code: 'COP', name: 'Colombian Peso', symbol: '$', minorUnits: 2 },
  { code: 'CRC', name: 'Costa Rican Colón', symbol: '₡', minorUnits: 2 },
  { code: 'CUP', name: 'Cuban Peso', symbol: '$', minorUnits: 2 },
  { code: 'CVE', name: 'Cape Verdean Escudo', symbol: '$', minorUnits: 2 },

  { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč', minorUnits: 2 },

  { code: 'DKK', name: 'Danish Krone', symbol: 'kr', minorUnits: 2 },
  { code: 'DOP', name: 'Dominican Peso', symbol: '$', minorUnits: 2 },
  { code: 'DZD', name: 'Algerian Dinar', symbol: 'دج', minorUnits: 2 },

  { code: 'EGP', name: 'Egyptian Pound', symbol: '£', minorUnits: 2 },
  { code: 'ERN', name: 'Eritrean Nakfa', symbol: 'Nfk', minorUnits: 2 },
  { code: 'ETB', name: 'Ethiopian Birr', symbol: 'Br', minorUnits: 2 },
  { code: 'EUR', name: 'Euro', symbol: '€', minorUnits: 2 },

  { code: 'FJD', name: 'Fijian Dollar', symbol: '$', minorUnits: 2 },
  { code: 'FKP', name: 'Falkland Islands Pound', symbol: '£', minorUnits: 2 },

  { code: 'GBP', name: 'British Pound Sterling', symbol: '£', minorUnits: 2 },
  { code: 'GEL', name: 'Georgian Lari', symbol: '₾', minorUnits: 2 },
  { code: 'GHS', name: 'Ghanaian Cedi', symbol: '₵', minorUnits: 2 },
  { code: 'GIP', name: 'Gibraltar Pound', symbol: '£', minorUnits: 2 },
  { code: 'GMD', name: 'Gambian Dalasi', symbol: 'D', minorUnits: 2 },
  { code: 'GNF', name: 'Guinean Franc', symbol: 'Fr', minorUnits: 0 },
  { code: 'GTQ', name: 'Guatemalan Quetzal', symbol: 'Q', minorUnits: 2 },
  { code: 'GYD', name: 'Guyanaese Dollar', symbol: '$', minorUnits: 2 },

  { code: 'HKD', name: 'Hong Kong Dollar', symbol: '$', minorUnits: 2 },
  { code: 'HNL', name: 'Honduran Lempira', symbol: 'L', minorUnits: 2 },
  { code: 'HRK', name: 'Croatian Kuna', symbol: 'kn', minorUnits: 2 },
  { code: 'HTG', name: 'Haitian Gourde', symbol: 'G', minorUnits: 2 },
  { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft', minorUnits: 2 },

  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', minorUnits: 2 },
  { code: 'ILS', name: 'Israeli New Shekel', symbol: '₪', minorUnits: 2 },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', minorUnits: 2 },
  { code: 'IQD', name: 'Iraqi Dinar', symbol: 'ع.د', minorUnits: 3 },
  { code: 'IRR', name: 'Iranian Rial', symbol: '﷼', minorUnits: 2 },
  { code: 'ISK', name: 'Icelandic Króna', symbol: 'kr', minorUnits: 0 },

  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', minorUnits: 0 },

  { code: 'KES', name: 'Kenyan Shilling', symbol: 'Sh', minorUnits: 2 },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', minorUnits: 0 },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', minorUnits: 3 },

  { code: 'LKR', name: 'Sri Lankan Rupee', symbol: 'Rs', minorUnits: 2 },

  { code: 'MAD', name: 'Moroccan Dirham', symbol: 'د.م.', minorUnits: 2 },
  { code: 'MXN', name: 'Mexican Peso', symbol: '$', minorUnits: 2 },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', minorUnits: 2 },

  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', minorUnits: 2 },
  { code: 'NPR', name: 'Nepalese Rupee', symbol: 'Rs', minorUnits: 2 },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: '$', minorUnits: 2 },

  { code: 'PHP', name: 'Philippine Peso', symbol: '₱', minorUnits: 2 },
  { code: 'PKR', name: 'Pakistani Rupee', symbol: 'Rs', minorUnits: 2 },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', minorUnits: 2 },

  { code: 'QAR', name: 'Qatari Rial', symbol: 'ر.ق', minorUnits: 2 },

  { code: 'RUB', name: 'Russian Ruble', symbol: '₽', minorUnits: 2 },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', minorUnits: 2 },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', minorUnits: 2 },
  { code: 'SGD', name: 'Singapore Dollar', symbol: '$', minorUnits: 2 },
  { code: 'THB', name: 'Thai Baht', symbol: '฿', minorUnits: 2 },
  { code: 'TRY', name: 'Turkish Lira', symbol: '₺', minorUnits: 2 },
  { code: 'USD', name: 'United States Dollar', symbol: '$', minorUnits: 2 },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', minorUnits: 2 }
];
